import { useTranslation } from "@/i18n";
import { Languages } from "lucide-react";

/**
 * Language switcher component that allows users to change the application language
 *
 * Displays current language and provides a toggle to switch between German and English.
 * The language choice is persisted in localStorage.
 */
export default function LanguageSwitcher() {
  const { language, setLanguage } = useTranslation();

  const toggleLanguage = () => {
    setLanguage(language === "de" ? "en" : "de");
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
      title={language === "de" ? "Switch to English" : "Zu Deutsch wechseln"}
    >
      <Languages size={18} className="text-gray-600" />
      <span className="text-sm font-medium text-gray-700 uppercase">
        {language}
      </span>
    </button>
  );
}
